export default "__VITE_ASSET__Nq7EzczF__"